import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user, isUserProfileIncomplete } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !loading && isUserProfileIncomplete(user) && location.pathname !== '/profile') {
      navigate('/profile', { replace: true, state: { from: location } });
    }
  }, [isAuthenticated, loading, user, isUserProfileIncomplete, location, navigate]);

  // Show loading while checking auth status
  if (loading) {
    return (
      <div className="app-container">
        <div className="splash-screen">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;